import { useState } from 'react';
import RolesHeader from 'components/roles/RolesHeader';
import RolesTabs from 'components/roles/RolesTabs';
import * as Tabs from '@radix-ui/react-tabs';
import { FiPlus } from 'react-icons/fi';
import RoleModal from 'components/roles/RoleModal';

export default function Roles() {
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('roles');

    return (
        <div className="px-6 pb-3 overflow-hidden overflow-y-auto h-full">
            <div className="pt-6 ">
                <RolesHeader />
            </div>

            <Tabs.Root defaultValue="roles" onValueChange={setActiveTab}>
              
                <RolesTabs 
                    activeTab={activeTab} 
                    onTabChange={setActiveTab} 
                />
            </Tabs.Root>

            <RoleModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                mode="create"
            />
        </div>
    );
} 